import React from "react";

import { DeprecatedSpinner } from "../Spinner/Spinner";
import { loadingWrapper } from "./CarouselLoader.css";

export const CarouselLoader = () => (
  <div data-testid="carousel-loader" className={loadingWrapper}>
    <DeprecatedSpinner type="componentLevel" />
  </div>
);
